import { gql } from '@apollo/client';
import { STUDY_SETTING_FRAGMENT } from '@/entities/study/@x/facility';

const FACILITY_FRAGMENT = gql`
  fragment FacilityFragment on Facility {
    id
    name
    contact {
      phone1
      fax
      faxes
      address
      city
      state
      country
      zip
      nightPhone
    }
    studySetting {
      ...StudySettingFragment
    }
    facilityNote
    status
    notificationEmail
    canUseBiofluxDirect
    canUseIcor
    faxReportManually
    faxReportAutomatically
    canSendReportEmail
    amplifyEcgSignal {
      biotresProDeviceRate
      biotresDeviceRate
      biofluxDeviceRate
    }
  }

  ${STUDY_SETTING_FRAGMENT}
`;

export default FACILITY_FRAGMENT;
